import { render, staticRenderFns } from "./LastUpdatesLogs.vue?vue&type=template&id=0001499a&"
import script from "./LastUpdatesLogs.vue?vue&type=script&lang=js&"
export * from "./LastUpdatesLogs.vue?vue&type=script&lang=js&"
import style0 from "./LastUpdatesLogs.vue?vue&type=style&index=0&id=0001499a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports